/* src/app/alarm/alarm.component.scss */
.tbl {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}
.tbl tr,
.tbl td {
  border: 1px solid #1B1C33;
}
.tbl tr:first-child,
.tbl tr:first-child td {
  border-top-width: 0;
}
.tbl tr,
.tbl td:first-child {
  border-left-width: 0;
}
.tbl tr,
.tbl td:last-child {
  border-right-width: 0;
}
/*# sourceMappingURL=alarm.component.css.map */
